export default {
  pageName: 'Guidelines - Topic',
  pageId: '25035',
  pagePath: '/opinion/MonitorScope',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
};
